import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/oneteam.webp';
import screenshot_target from '../../../images/letterfunnel/rubenwieman.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Ruben Wieman"
      firstname="Ruben"
      companyname="Oneteam"
      competition="Connecteam en Beekeeper"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/rubenwieman.js